import { forwardRef } from 'react';
import format from 'date-fns/format';

import DateInputInline, {
  DateInputInlineSelect,
} from 'components/Inputs/inline/DateInput';
import { ApplySelectOverlayButton } from 'components/Inputs/SelectOverlay';
import { API_DATE_FORMAT } from 'services/helpers';
import { withCellWrapper } from '../helpers';

import { getDataQAForInput } from 'components/Inputs/helpers';

const _EstimatedCloseDateCell = forwardRef(
  (
    {
      field,
      entityId,
      onSubmit,
      value,
      objectId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      editable,
      onAutoFocus,
      meta,
      ...others
    },
    ref
  ) => {
    return (
      <DateInputInline
        ref={ref}
        {...others}
        field={field}
        entityId={entityId}
        objectId={objectId}
        value={undefined} // Overriding base.props, value should be passed to DateInputInlineSelect
        onSubmit={async (data) => {
          const value = data ? format(data, API_DATE_FORMAT) : data;
          await onSubmit(value);
        }}
        readOnly={readOnly}
        onAutoFocus={onAutoFocus}
        {...getDataQAForInput(
          `inline-record-field-${field.name}`,
          field.fieldType
        )}
      >
        <DateInputInlineSelect
          value={value}
          menuLeftButton={menuLeftButton}
          menuRightButton={<ApplySelectOverlayButton />}
        />
      </DateInputInline>
    );
  }
);

export const EstimatedCloseDateCell = withCellWrapper(_EstimatedCloseDateCell);
